import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from "../../axios";
import Alert from "react-s-alert";
import CustomModal from "../../components/CustomModal";
import moment from "moment";
import qs from "qs";
import Paging from "../../components/Paging";
import DatePicker from 'react-datepicker';

class Lists extends Component {
	constructor() {
		super();
		this.state = {
			dataReport: [],
            pageCount: 0,
            currentPage: 0,
            user_id: "",
            isLoading: true,
            isButtonLoading: false,
            isModalShow: false
		};

		this.handlePageClick = this.handlePageClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.handleSubmitDeleteButton = this.handleSubmitDeleteButton.bind(this);
	}

	toggleModal() {
		this.setState({ isModalShow: !this.state.isModalShow });
	}

	handleSubmitDeleteButton() {
		// Alert.error("BELUM ADA APINYA");

		// this.toggleModal();

		axios({
		    method: 'get',
		    url: '/iuran/forward/delete/' + this.state.forward_id
		})
		    .then(response => {
				const result = response.data;
				
		        Alert.success(result.message);
		        this.loadData();
		        this.toggleModal();

		        return;
		    })
		    .catch(error => {

		        this.setState({ isLoading: false })
		        Alert.error("Gagal terhubung ke server!")
		    })
	}

	handleChange(event) {

        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        })

    }

	handlePageClick(data) {
		let selected = data.selected; // zero based index

		this.setState({ currentPage: selected }, () => {
			this.loadData();
		});
	}

	loadData() {
		this.setState({isLoading: true, isButtonLoading: true})

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            user: this.state.user_id,
        })

        axios.get("/iuran/forward?" + params)

            .then(response => {
                const result = response.data

                if (result.success === true) {
                    this.setState({
                        dataReport: result.data.data,
                        pageCount: result.data.last_page,
                        isLoading: false,
                        isButtonLoading: false
                    });
                } else {
                    Alert.error(result.message);
                    this.setState({isLoading: false});
                }

            })

            .catch(error => {
                this.setState({isLoading: false});
                Alert.error("Gagal terhubung ke server!");
            });
	}

	componentDidMount() {
		this.loadData();
	}

	render() {
		return (
			<div className="col-sm-12">
				
				<CustomModal
					isShow={this.state.isModalShow}
					toggleModal={this.toggleModal}
					handleSubmit={this.handleSubmitDeleteButton}
					modalHeaderText="Hapus Data"
					modalBodyText="Anda yakin ingin menghapus data ini?"
					modalSubmitText="Ya"
				/>

                <div className="card">
                    <div className="card-header">
                        Forward Tagihan
                    </div>
                    <div className="card-block">
                        <div className="form-group row">

                            <div className="col-md-2">
                                <NavLink
                                    to={`${this.props.match.url}/add`}
                                    className="btn btn-primary btn-sm"
                                        style={{margin: 3,
                                        borderRadius:3}}

                                >
                                    Tambah Data Baru
                                </NavLink>
                            </div>
                        </div>
                        <hr/>
                        {
                            this.state.isLoading ? "Memuat Data..." : (
                                this.state.dataReport.length === 0 ? "Data tidak ditemukan..." : (
                                    <div>
                                        <table className="table table-striped table-bordered animated fadeIn">
                                            <thead>
                                            <tr>
                                                <th>Forward</th>
                                                <th>Nominal</th>
                                                <th>Action</th>
                                                <th>Penetapan</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                this.state.dataReport.map((item, i) => {

                                                    return (
                                                        <tr key={item.forward_id}>
                                                            <td>{item.forward_nama}</td>
                                                            <td>{item.forward_nominal}</td>
                                                            <td>
                                                            <NavLink to={`${this.props.match.url}/edit/${item.forward_id}`}
                                                            className="btn btn-primary btn-sm"
                                                            style={{margin: 3,
                                                                borderRadius:3}}>Edit </NavLink>

															<button
																type="button"
																className="btn btn-danger btn-sm"
																onClick={() => {
																	this.toggleModal();
																	this.setState({ forward_id: item.forward_id });
																}}
															>
																Hapus
															</button>
                                                                            
                                                            </td>
                                                            <td>
                                                            	<NavLink to={`${this.props.match.url}/penetapan/${item.forward_id}/${btoa(item.forward_nama)}`}
																	className="btn btn-primary btn-sm"
																		style={{margin: 3,
																		borderRadius:3}}>Penetapan Siswa </NavLink>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>
                                        <Paging
                                            handlePageClick={this.handlePageClick}
                                            pageCount={this.state.pageCount}
                                            currentPage={this.state.currentPage}
                                        />
                                    </div>
                                )
                            )
                        }

                    </div>
                </div>
            </div>
		);
	}
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/ForwardIuran/Lists.js